// extracted by mini-css-extract-plugin
module.exports = {"container":"e_IB","widget":"e_JB","title":"e_KB","msrp":"e_LB","separator":"e_MB","textBadge":"e_NB"};